export default "/images/team-vous-recrutez.webp?2709476c102e6186a109067883cf5b3a";